'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Wrapper around the ngRouter to allow nested routes inside a page.
 */
ngModule.factory("$pageRouter", function ($rootScope, $route, routeUtils) {
  var locationHandlers = [];
  var currentRoute = $route.current,
    previousRoute = null,
    nextRoute = null;
  $rootScope.$on("$routeChangeStart", function (event, _nextRoute, _previousRoute) {
    previousRoute = _previousRoute;
    nextRoute = _nextRoute;
  });
  $rootScope.$on('$locationChangeSuccess', function (event, newUrl, oldUrl) {
    currentRoute = nextRoute;
    var matched = false;

    //console.log("location change", oldUrl, newUrl);

    _.each(locationHandlers, function (locationHandler) {
      var regexp = locationHandler.regexp,
        oldFragment = regexp.exec(oldUrl),
        newFragment = regexp.exec(newUrl);
      if (oldFragment && newFragment && oldFragment[0] !== newFragment[0]) {
        locationHandler.handler(nextRoute.params);
        matched = true;
        // console.log("handler matched", locationHandler.route, oldFragment[0], newFragment[0] );
      }
    });

    // same section -> we hyjack the router behaviour by putting back the old route as $route.current.
    if (matched && previousRoute != null) {
      // console.log("***** current route = ", previousRoute)
      $route.current = previousRoute;
    }
  });
  return {
    getCurrentRoute: function getCurrentRoute() {
      return currentRoute || $route.current;
    },
    registerLocationHandler: function registerLocationHandler(routeSegment, handler) {
      var locationHandler = {
        route: routeSegment,
        regexp: routeUtils.getRouteRegexp(routeSegment, false),
        handler: handler
      };
      locationHandlers.push(locationHandler);
      return function unregister() {
        var handlerIdx = _.indexOf(locationHandlers, locationHandler);
        if (handlerIdx > -1) {
          locationHandlers.splice(handlerIdx, 1);
        }
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/pageRouter.js
// module id = 2980
// module chunks = 13